(ns core.domain.validators
  (:require #?(:cljs [core.front.date-util :as date-util])
            [clojure.string :as str]
            [schema.core :as s])
  #?(:clj (:import [java.util Date])))

(defn valid-email?
  "Validates email is in correct form"
  [email]
  (let [pattern #"[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"]
    (boolean (and (string? email) (re-matches pattern email)))))

(defn valid-optional-email?
  [email]
  (or (str/blank? email) (valid-email? email)))

(def NotEmptyStr (s/constrained s/Str not-empty "Not empty string"))

(def FutureDate
  #?(:clj (s/pred #(.after ^Date % (Date.)) 'future-date)
     :cljs (s/pred #(date-util/after? % (js/Date.)) 'future-date)))

(defn valid-phone-number?
  "Phone number is valid if it consists only of separator characters and
  numbers (max 15). Can be prefixed with +."
  [phone-number]
  (boolean (when (string? phone-number)
             (as-> phone-number $
                   (str/replace $ #"-|\(|\)|\[|\]|\s|\{|\}" "")
                   (re-matches #"^\+?\d{1,15}$" $)))))

(defn valid-domain?
  "Validate (loosely) that domain part looks legit (eg no 'https://' contained)."
  [domain-string]
  (some? (re-matches #"[\w-.]+" domain-string)))


(def valid-uri? (partial re-matches #"^https?://.+"))

(defn valid-uuid? [uuid-str]
  (some? (parse-uuid uuid-str)))
